import { Component, effect, inject, Input, OnInit } from '@angular/core';

import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { NavItem } from '../../../../core/models/nav-item.model';
import { SettingsService } from '../../../services/settings.service';
import { NavService } from '../../../../core/services/nav.service';
import { EzBaseComponent } from '@template-ui/components/ez-base.component';
import { SideMenuItemComponent, NavItemWithEvent } from '../side-menu-item/side-menu-item.component';
import { CommonModule } from "@angular/common";


interface MenuItem {
  displayName: string;
  iconName?: string;
  route?: string;
  expanded?: boolean;
  children?: MenuItem[];
  isActive?: boolean;
  action?: () => void;
}
@Component({
    selector: "app-side-nav",
    imports: [
        // Angular stuff
        CommonModule,
        // Material stuff
        MatSidenavModule, MatListModule, MatIconModule,
        // App navigation
        SideMenuItemComponent
    ],
    templateUrl: "./side-nav.component.html",
    styleUrls: ["./side-nav.component.scss"],
    animations: [
        trigger("indicatorRotate", [state("collapsed", style({ transform: "rotate(270deg)" })), state("expanded", style({ transform: "rotate(360deg)" })), transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4,0.0,0.2,1)"))])
    ]
})
export class SideNavComponent extends EzBaseComponent implements OnInit {
  @Input() sideNav!: MatSidenav;
  @Input() menuItems: NavItem[] = [];

  activeItem?: NavItem;

  private history: string[] = [];

  settingsService = inject(SettingsService);

  constructor(private navService: NavService) {
    super();

    // Get the menu items when they're ready
    effect(() => {
      //console.log(`Effect triggered by menuItems`);
      // Triggers
      this.menuItems = this.navService.sideNavMenuItems();

      // Do stuff
      this.highlightActiveItem();
    });

    // Highlight the active item when the route changes
    // NOTE: This is the first attempt at using a signal converted from an RxJs event. Is it better?
    effect(() => {
      const signal = this.navigationEndSignal();
      if (signal) {
        this.history.push(signal.urlAfterRedirects);
        this.highlightActiveItem();
      }
    });
  }

  highlightActiveItem() {
    // Clear the current active item
    this.menuItems.forEach((item) => {
      item.isActive = false;
    });

    const urlWithoutFragment = this.router.url.split("#")[0];

    this.activeItem = this.menuItems.find((item) => item.route?.endsWith(urlWithoutFragment));
    if (this.activeItem) {
      this.activeItem.isActive = true;
    }
  }

  ngOnInit(): void {}


  onSidenavNavRequest(NavItemWithEvent: NavItemWithEvent) {
    // preventClose doesn't work because clicking a link with the shift causes the page to open in a new window
    // Ctl opens in new tab
    // Alt causes download
    // Ctl+alt opens in a new tab
    // Ctl+shift opens in a new window
    const preventClose: boolean = NavItemWithEvent.event?.shiftKey;
    if (!preventClose) {
      setTimeout(() => {
        this.sideNav.close().catch(err => console.error("Failed to close sidename."));
      }, 100);
    }
  }

  private dirtyNoticeDetail: boolean = false;
  private dirtyNoticeResponse: boolean = false;
  get UnsavedNoticeChanges() {
    return this.dirtyNoticeDetail || this.dirtyNoticeResponse;
  }

  unsavedChanges() {
    // // TODO: Add in other pages to check for clemency, et al
    // if (this.UnsavedNoticeChanges) {
    //   return this.displayUnsavedChangesDialog();
    // } else {
    //   return of(true);
    // }
  }

}
